export default {
  config: state => state.config,
  results: state => state.results,
  translation: state => key => state.translations[key],
  translations: state => state.translations,
};
